import { bunja } from 'bunja';
import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';

import { putUserProfileApi } from '@flipster/apis/v1/user';
import { snackbar } from '@flipster/react/design-system/snackbar';
import { getErrorMessage } from '@flipster/utils/error';

import { UserProfileQueryKey } from '../../profile-page/bunja';
import { profileFeedQueryKey } from '../../profile-page/section/feed-section/bunja';
import { getMeQueryKey } from '../auth/state';
import { CommunityFeedQueryKey, InsightsFeedQueryKey } from '../community-feed/post-and-edit/bunja';

export const profileSettingBunja = bunja(() => {
  const putUserProfileMutationAtom = atomWithMutation((get) => ({
    mutationKey: ['putUserProfileApi'],
    mutationFn: putUserProfileApi,
    onSettled: async () => {
      const queryClient = get(queryClientAtom);
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: UserProfileQueryKey }),
        queryClient.invalidateQueries({ queryKey: [CommunityFeedQueryKey] }),
        queryClient.invalidateQueries({ queryKey: [InsightsFeedQueryKey] }),
        queryClient.invalidateQueries({ queryKey: [profileFeedQueryKey] }),
        queryClient.invalidateQueries({ queryKey: [getMeQueryKey] }),
      ]);
    },
    onError(error) {
      snackbar.error({ message: getErrorMessage(error) });
    },
  }));

  return { putUserProfileMutationAtom };
});
